import { createElementVNode as _createElementVNode, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/exit-browser.png'


const _withScopeId = n => (_pushScopeId("data-v-2988236e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details" }
const _hoisted_2 = { class: "setting" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Infinite Fates", -1))
const _hoisted_4 = { class: "setting" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Roll", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Normally", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "5" }, "Only 5-star items", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "4" }, "Only 4- and 5-star items", -1))
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "setting" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Win 50/50", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Normally", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Always", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Never", -1))
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "setting" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Unlimited history scrolling", -1))
const _hoisted_18 = { class: "setting" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Everyone is here?", -1))
const _hoisted_20 = { class: "setting" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Show banner pity in history", -1))
const _hoisted_22 = { class: "setting" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Export "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://paimon.moe" }, "paimon.moe"),
  /*#__PURE__*/_createTextVNode(" wish data")
], -1))
const _hoisted_24 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "header",
      onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.exit && _ctx.exit(...args)), ["esc"]))
    }, [
      _createElementVNode("img", {
        src: _imports_0,
        class: "exit-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exit && _ctx.exit(...args)))
      })
    ], 32),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.settings.infinitePrimos) = $event)),
          type: "checkbox",
          class: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.settings.infinitePrimos]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.settings.rollOnly) = $event)),
          class: "combobox"
        }, _hoisted_9, 512), [
          [_vModelSelect, _ctx.settings.rollOnly]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.settings.winGuarantee) = $event)),
          class: "combobox"
        }, _hoisted_15, 512), [
          [_vModelSelect, _ctx.settings.winGuarantee]
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.settings.unlimitedHistoryScroll) = $event)),
          type: "checkbox",
          class: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.settings.unlimitedHistoryScroll]
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.settings.everythingBanner) = $event)),
          type: "checkbox",
          class: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.settings.everythingBanner]
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.settings.showBannerPity) = $event)),
          type: "checkbox",
          class: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.settings.showBannerPity]
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("a", {
          href: _ctx.paimonExportJson,
          download: "paimon.json"
        }, "Download", 8, _hoisted_24)
      ])
    ])
  ], 64))
}